export default __webpack_public_path__ + "static/media/guideme_lancingkit_lancets100_strips150_scale_gray@3x.68db3a83.jpg";